import { z } from 'zod';

export const ChartPointSchema = z.object({
  x: z.string(),
  y: z.number(),
});

export const ChartPointsSchema = z.array(ChartPointSchema);

export const ChartSerieSchema = z.object({
  name: z.string(),
  color: z.string().optional(),
  data: ChartPointsSchema,
});

export const ChartSeriesSchema = z.array(ChartSerieSchema);

export type ChartPoint = z.infer<typeof ChartPointSchema>;
export type ChartPoints = z.infer<typeof ChartPointsSchema>;
export type ChartSerie = z.infer<typeof ChartSerieSchema>;
export type ChartSeries = z.infer<typeof ChartSeriesSchema>;
